const dataTypeConfigDefaults = {
    state: {},
    meta: { path: [], unmappedPath: [] },
};
const createObjectDataTypeConfig = (input) => ({
    kind: 'OBJECT',
    typeName: 'Object',
    isNullable: true,
    fields: [],
    directives: [],
    ...dataTypeConfigDefaults,
    ...input,
});
const createScalarDataTypeConfig = (input = {}) => ({
    kind: 'SCALAR',
    typeName: 'String',
    isNullable: true,
    directives: [],
    ...dataTypeConfigDefaults,
    ...input,
});
const createFieldDataTypeConfig = (input) => ({
    kind: 'FIELD',
    typeName: 'Field',
    isNullable: true,
    args: [],
    directives: [],
    ofType: input.ofType ?? createScalarDataTypeConfig(),
    ...dataTypeConfigDefaults,
    ...input,
});
const createTypeReferenceDataTypeConfig = (input) => ({
    kind: 'TYPE_REFERENCE',
    typeName: 'String',
    isNullable: true,
    directives: [],
    ...dataTypeConfigDefaults,
    ...input,
});
const createListDataTypeConfig = (input) => ({
    kind: 'LIST',
    typeName: 'List',
    isNullable: true,
    ofType: input.ofType ?? createScalarDataTypeConfig(),
    directives: [],
    ...dataTypeConfigDefaults,
    ...input,
});
const createInputValueDataTypeConfig = (input) => ({
    kind: 'INPUT_VALUE',
    typeName: 'InputValue',
    isNullable: true,
    ofType: input.ofType ?? createScalarDataTypeConfig(),
    defaultValue: input.defaultValue ?? null,
    directives: [],
    ...dataTypeConfigDefaults,
    ...input,
});
const createInputObjectDataTypeConfig = (input) => ({
    kind: 'INPUT_OBJECT',
    isNullable: true,
    fields: [],
    directives: [],
    ...dataTypeConfigDefaults,
    ...input,
});
const createUnionDataTypeConfig = (input) => ({
    kind: 'UNION',
    isNullable: true,
    possibleTypes: [],
    directives: [],
    ...dataTypeConfigDefaults,
    ...input,
});
const createEnumDataTypeConfig = (input) => ({
    kind: 'ENUM',
    isNullable: true,
    enumValues: [],
    directives: [],
    ...dataTypeConfigDefaults,
    ...input,
});
const createEnumValueDataTypeConfig = (input) => ({
    kind: 'ENUM_VALUE',
    typeName: 'EnumValue',
    isNullable: true,
    directives: [],
    ...dataTypeConfigDefaults,
    ...input,
});
export const DataTypeConfigU = {
    createObjectDataTypeConfig,
    createTypeReferenceDataTypeConfig,
    createListDataTypeConfig,
    createInputValueDataTypeConfig,
    createInputObjectDataTypeConfig,
    createScalarDataTypeConfig,
    createFieldDataTypeConfig,
    createUnionDataTypeConfig,
    createEnumDataTypeConfig,
    createEnumValueDataTypeConfig,
};
//# sourceMappingURL=DataTypeConfig.js.map